import { SIGNUP_URL, WALKTHROUGH_URL } from "../data";
import { track } from "@/lib/analytics";

export default function ProductsHero() {
  return (
    <section className="relative overflow-hidden bg-background-50 px-4 md:px-8">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[760px] h-[760px] rounded-full joble-glow-accent"></div>
        <div className="absolute top-24 -left-40 w-[520px] h-[520px] rounded-full joble-glow-primary"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto pt-14 md:pt-20 pb-14 md:pb-16 text-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-background-300/50 bg-background-100/60 px-4 py-1.5 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-xs font-medium text-foreground-800 tracking-wide">
            How Joble does it
          </span>
        </div>

        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-medium text-foreground-950 leading-[1.08] tracking-tight">
          Three agents. One job: never lose a customer.
        </h1>

        <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed max-w-2xl mx-auto">
          Joble is not one trick. It is a web agent, a phone agent and a workspace that work
          together, so every question gets an answer and every answer has a next step.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={SIGNUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("try_joble_clicked", { location: "products_hero_primary" })}
            className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 rounded-full bg-primary-500 text-foreground-950 font-semibold text-base px-8 py-4 hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Try Joble Now
            <span className="w-7 h-7 rounded-full bg-foreground-950/15 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
              <i className="ri-arrow-right-line text-foreground-950" aria-hidden></i>
            </span>
          </a>
          <a
            href={WALKTHROUGH_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("book_demo_clicked", { location: "products_hero_secondary" })}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border border-background-300/60 text-foreground-900 font-semibold text-base px-8 py-4 hover:bg-background-100/70 transition-colors cursor-pointer whitespace-nowrap"
          >
            Book a walkthrough
          </a>
        </div>
      </div>
    </section>
  );
}